import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import EfBanner from '@elem/ui/ef-banner';
import { getIsMobileWidth2 } from '@elem/utils/devices';
import styles from './index.module.scss';

const VIDEO_MAP = {
    eu: 'https://www.youtube.com/embed/cLShSDgEOdc?si=EpVYHIv67AenFL_B',
    uk: 'https://www.youtube.com/embed/cLShSDgEOdc?si=EpVYHIv67AenFL_B',
    fr: 'https://www.youtube.com/embed/sMKe7KKjTmw?si=C_is7z7m-xlxxMWt',
    it: 'https://www.youtube.com/embed/MjBwJT5Y9vI?si=uYWXqyehDVlEbRYD',
    es: 'https://www.youtube.com/embed/mg8OiH8VGpM?si=CDQjipiIiRKL9QDc',
    de: 'https://www.youtube.com/embed/H3cqluyFrRU?si=Os8hUtTPmWlrzIlL',
};

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale } = useRouter();
    const { gtm } = useGlobal();
    const itemA = {
        desc: t('banner_desc'),
        pc:
            locale === 'uk'
                ? 'https://websiteoss.ecoflow.com/upload/image/1724143551933/kv_banner_uk.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1724143473227/kv_banner.jpg',
        h5:
            locale === 'uk'
                ? 'https://websiteoss.ecoflow.com/upload/image/1724206604147/kv_banner_h5_uk.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1724206604140/kv_banner_h5.jpg',
        btn_text: t('banner_btn_2'),
        btn_link: VIDEO_MAP[locale as keyof typeof VIDEO_MAP] || VIDEO_MAP.eu,
        // btn_text2: t('banner_btn_2'),
        // btn_link2: 'https://www.youtube.com/embed/ozVzv0jo_BM',
    };

    const [titleText, setTitleText] = useState({
        title: t('banner_title'),
        ...itemA,
    });

    useEffect(() => {
        const isMobile = getIsMobileWidth2(); //是否是移动端
        if (!!isMobile) {
            setTitleText({
                title: t('banner_title_h5'),
                ...itemA,
            });
        } else {
            setTitleText({
                title: t('banner_title'),
                ...itemA,
            });
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfBanner {...titleText} gtm_title_name="RIVER 2 Series" gtm_position="Product Preview_1" theme="black" />
        </div>
    );
}
